module.exports = __webpack_public_path__ + "static/exo-v6-latin-regular-4ce55dc9d7e9ea9fa2aa61bb16b0b285.svg";